import {
  addActionInSubsetReducer,
  deleteActionInSubsetReducer,
  updateActionInSubsetReducer,
} from '../../helpers/recipesReducerHelpers';
import {CsatEditorActionTypesEnum, CsatEditorSpecificAction} from './csatEditorActions';
import {CsatEditorSpecificState} from './csatEditorState';

/*
 * Reducer.
 */

export function csatEditorSpecificReducer(
  state: CsatEditorSpecificState,
  action: CsatEditorSpecificAction,
): CsatEditorSpecificState {
  switch (action.type) {
    case CsatEditorActionTypesEnum.SET_DELAY_SINCE_TRIGGER:
      return {
        ...state,
        delaySinceTrigger: action.payload,
      };

    case CsatEditorActionTypesEnum.SET_RESPONSE:
      return {
        ...state,
        response: action.payload,
      };

    case CsatEditorActionTypesEnum.SET_TAG:
      return {
        ...state,
        tags: {
          ...state.tags,
          [action.payload.subset]: action.payload.tagId,
        },
      };

    case CsatEditorActionTypesEnum.ADD_ACTION:
      return addActionInSubsetReducer(state, action.payload.action, action.payload.subset);

    case CsatEditorActionTypesEnum.UPDATE_ACTION:
      return updateActionInSubsetReducer(
        state,
        action.payload.predicate,
        action.payload.update,
        action.payload.subset,
      );

    case CsatEditorActionTypesEnum.DELETE_ACTION:
      return deleteActionInSubsetReducer(state, action.payload.predicate, action.payload.subset);

    default:
      return state;
  }
}
